import { render, staticRenderFns } from "./JdOrderDetail.vue?vue&type=template&id=22e6de14&scoped=true&"
import script from "./JdOrderDetail.vue?vue&type=script&lang=js&"
export * from "./JdOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6de14",
  null
  
)

export default component.exports